<template>
  <div>
    <div class="planning-selector__select">
      <h1>Voir la campagne :</h1>
      <MultiSelect
        class="filters__multiselect planning-selector__input"
        v-model="value"
        placeholder="Campagne - Mois"
        label="name"
        track-by="id"
        :options="plannings"
        :searchable="false"
        :close-on-select="true"
        :show-labels="false"
      >
        <template slot="noOptions">
          La liste est vide
        </template>
        <template slot="noResult">
          Aucun élément trouvé
        </template>
      </MultiSelect>
    </div>
    <div class="planning-selector__select" v-if="value">
      <h1>Pharmacie :</h1>
      <MultiSelect
        class="filters__multiselect planning-selector__input"
        v-model="pharmacy"
        placeholder="Campagne - Pharmacies"
        label="company"
        track-by="id"
        :options="pharmacies"
        :searchable="false"
        :close-on-select="true"
        :show-labels="false"
      >
        <template slot="noOptions">
          La liste est vide
        </template>
        <template slot="noResult">
          Aucun élément trouvé
        </template>
      </MultiSelect>
    </div>
    <p v-if="!pharmacy">
      Veuillez selectionner une {{ value === null ? "campagne" : "pharmacie" }}
    </p>
  </div>
</template>

<script>
import MultiSelect from "vue-multiselect"
import { getPharmaciesOfCampaign } from "@/api/campaigns"
export default {
  components: {
    MultiSelect
  },
  props: {
    plannings: {
      type: Array,
      required: true
    }
  },
  computed: {
    PharmacyName() {
      return this.pharmacies.map(({ name }) => name)
    }
  },
  methods: {
    getCampaignPharmacies(campaignId) {
      getPharmaciesOfCampaign(campaignId)
        .then(plannings => {
          this.pharmacies = plannings.data
        })
        .catch(err => {
          console.error(err)
        })
    }
  },
  data: () => ({
    value: null,
    options: [],
    pharmacy: null,
    pharmacies: [],
    campaign: null
  }),
  created() {
    this.plannings.forEach(planning => {
      this.options.push(planning.name + " " + planning.scheduled_at)
    })
  },
  watch: {
    value() {
      /*let indexOfPlanning = this.options.indexOf(this.value)
      this.pharmacies = []
      this.pharmacy = null
      this.plannings[indexOfPlanning].pharmacies.forEach(pharmacy => {
        this.pharmacies.push(pharmacy)
      })*/
      this.getCampaignPharmacies(this.value.id)
      this.$emit("campaignChanged", this.value)
    },
    pharmacy(pharmacy) {
      /*var selectedPharmacy = this.pharmacies
        .filter(({ name }) => name)
        .find(selected => selected.name === newPharmacy)*/
      this.$emit("pharmacyChanged", pharmacy)
    }
  }
}
</script>

<style lang="scss">
.planning-selector {
  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__input {
    width: 100%;
    max-width: 350px;
  }
}
</style>
